import { type UseQueryOptions, useQuery } from "@tanstack/react-query";
import { useAuth } from "react-oidc-context";
import { type GetAgentLocationResult, getAgentLocation } from "../utils/getAgentLocation";

export function useAgentOrgChartLocation(params: Partial<UseQueryOptions<GetAgentLocationResult>>) {
    const employeeId = useAuth().user?.profile.employeeID ?? "";

    return useQuery({
        queryKey: ["get-agent-site", employeeId],
        queryFn: async () => await getAgentLocation(),
        ...params,
    });
}
